import { SummaryTab } from '@/features/sales/SummaryTab';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/sales/summary')({
  validateSearch: z.object({
    preset: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
  }),
  component: SummaryTab,
});
